exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#platform {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border-radius: 5px;\n}\n.detail-data {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-top: 30px;\n}\n.alert-title {\r\n  margin-top: 18px;\n}\r\n", ""]);

// exports
